import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { Menu } from '../../../components'
import { IcoPrioridade } from '../../../components/icon/base/icoprioridade'
import { IcoCiclo } from '../../../components/icon/base/icociclo'
import { IcoHistoria } from '../../../components/icon/base/icohistoria'
import { IcoBlacklist } from '../../../components/icon/base/icoblacklist'
import { IcoIntegracao } from '../../../components/icon/base/icointegracao'
import { IcoContextoestrategico } from '../../../components/icon/base/icocontextoestrategico'
import './pdcaSidebar.scss'


export default ({ sidebarMobileOpen = false }) => {
  const { idProjetos } = useParams()
  const { grupos, grupo, filters, empresa, categoria, sistema, projeto } = useSelector(state => state.layoutState)
  const nls = require(`./nls/${sistema.idioma}.json`)

  const podeGerirProjeto = projeto?.permissaoPdcaGerirProjeto === true

  const [menuPdca, setMenuPdca] = useState([])

  useEffect(() => {
    setMenuPdca([
      {
        id: 'PdcaPriorities',
        label: nls.menuPriorities,
        icon: <IcoPrioridade />,
        go: `/myprojects/${idProjetos}/pdca/priorities`,
      },
      {
        id: 'PdcaCycle',
        label: nls.menuCycle,
        icon: <IcoCiclo />,
        sub: [
          {
            id: 'PdcaPlan',
            label: nls.menuPlan,
            go: `/myprojects/${idProjetos}/pdca/plan`,
          },
          {
            id: 'PdcaDo',
            label: nls.menuDo,
            go: `/myprojects/${idProjetos}/pdca/do`,
          },
          {
            id: 'PdcaCheck',
            label: nls.menuCheck,
            go: `/myprojects/${idProjetos}/pdca/check`,
          },
          {
            id: 'PdcaAct',
            label: nls.menuAct,
            go: `/myprojects/${idProjetos}/pdca/act`,
          }
        ]
      },
      {
        id: 'PdcaHistory',
        label: nls.menuHistory,
        icon: <IcoHistoria />,
        go: `/myprojects/${idProjetos}/pdca/history`,
      },
      ...(podeGerirProjeto ? [
        {
          id: 'PdcaBlacklist',
          label: nls.menuBlacklist,
          icon: <IcoBlacklist />,
          go: `/myprojects/${idProjetos}/pdca/blacklist`,
        },

        {
          id: 'PdcaStrategicContext',
          label: nls.menuStrategicContext,
          icon: <IcoContextoestrategico />,
          go: `/myprojects/${idProjetos}/pdca/strategic-context`,
        },

        {
          id: 'PdcaIntegrations',
          label: nls.menuIntegrations,
          icon: <IcoIntegracao />,
          go: `/myprojects/${idProjetos}/pdca/integrations`,
        }
      ] : [])
    ])
  }, [idProjetos, sistema.idioma])

  return (
    <div className={`box-pdca-sidebar ${sidebarMobileOpen ? 'open-sidebar' : ''}`}>
      <div className='box-pdca-sidebar-scroll'>
        <Menu data={menuPdca} action={() => {}} />
      </div>
    </div>
  )
}